module.exports = __webpack_public_path__ + "static/media/Amal Samji.1f295af9.jpg";